import { render } from "./IssueSidebar.vue?vue&type=template&id=21bf3e40&scoped=true"
import script from "./IssueSidebar.vue?vue&type=script&lang=js"
export * from "./IssueSidebar.vue?vue&type=script&lang=js"

import "./IssueSidebar.vue?vue&type=style&index=0&id=21bf3e40&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3595080301/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bf3e40"]])

export default __exports__